



import { Eye } from "lucide-react";
import moment from "moment";
import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { customTableStyles } from "../../../utils/tableStylings";

const CompanyExpensesReport = ({ data, onReady }) => {

    const number_format = (number, decimals = 2) => {
        const n = Number(number);
        return n.toLocaleString("en-IN", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    };

    // ------- Calculate Totals -------
    const totalCount = data.data?.length;

    const totalAmount = data.total_expenses;

    const expensesCompanyCol = [
        { name: "Date", selector: (row) => moment(row.expense_date).format('DD MMM, YYYY'), sortable: true },
        { name: "Title", selector: (row) => row.title, sortable: true },
        { name: "Category", selector: (row) => row.category, sortable: true },
        { name: "Note", selector: (row) => row.note, sortable: true },
        { name: "Amount", selector: (row) => number_format(Number(row.amount)), sortable: true },
    ];


    const processedRows = data.data?.map(row => {
        const obj = {};
        expensesCompanyCol.forEach(col => {
            obj[col.name] = col.selector(row);
        });
        return obj;
    });

    const totals = {
        "": "",
        "": "",
        "": "",
        "Amount": totalAmount,
        "": "",
    };


    // FIX HERE — useEffect so it does NOT run every render
    useEffect(() => {
        if (onReady) {
            onReady({ expensesCompanyCol, processedRows, totals });
        }
    }, [data]); // run ONLY when data changes


     const statsConfig = [
        {
            label: "Total Counts",
            value: totalCount,
            bg: "#FFF7ED",
            color: "#4338CA"
        },
        {
            label: "Total Amount",
            value: number_format(totalAmount),
            bg: "#FEF2F2",
            color: "#15803D"
        }
    ];

    
    const StatsCards = () => (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px",
                marginBottom: "15px",
                marginTop: "20px"
            }}
        >
            {statsConfig.map((item, index) => (
            <div
                key={index}
                style={{
                ...cardStyle,
                backgroundColor: item.bg,
                borderLeft: `5px solid ${item.color}`
                }}
            >
                <div style={{ ...labelStyle, color: item.color }}>
                {item.label}
                </div>
                <div style={{ ...valueStyle, color: item.color }}>
                {item.value}
                </div>
            </div>
            ))}
        </div>
    );

    const cardStyle = {
        padding: "15px",
        background: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #e5e7eb",
    };

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        fontWeight: "500",
    };

    const valueStyle = {
        fontSize: "20px",
        fontWeight: "700",
        color: "#111827",
        marginTop: "5px",
    };

    return (
        <>
            <StatsCards />
            <DataTable
                columns={expensesCompanyCol}
                data={data.data || []}
                pagination={false}
                highlightOnHover
                striped
                dense
                customStyles={customTableStyles}
            />


            {/* Footer Below Table */}

        </>
    );
};

export default CompanyExpensesReport;